import { useQuery } from "@tanstack/react-query";

import type { NamespaceIdentification } from "../core/application/store/namespace-identification";
import { useNavigationApi } from "../hooks";

export const useQueryNamespaceIdentification = (namespaceId?: string) => {
  const { api } = useNavigationApi();

  return useQuery<NamespaceIdentification>({
    queryKey: ["organization/namespace/:namespaceId/identification", namespaceId],
    queryFn: () => api.navigation.getNamespaceIdentification(namespaceId ?? ""),
    enabled: !!namespaceId,
  });
};
